import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ContentModuleViewerSkeleton = () => (
  <div
    className="content-details-module-skeleton"
    aria-label="Carregando conteúdo selecionado"
    aria-busy="true"
  >
    <Skeleton height="100%" />
  </div>
);

export default ContentModuleViewerSkeleton;
